import { apiRequest } from "@/services/api/apiClient.js";

const path = "/radius/layout"
export async function getAttributeLayout({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: `${path}`,
        params: { page, limit, ...filters },
    });
}

export async function getVarTemplates() {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: `/radius/varTemplates`,
        params: {},
    });
}

export async function deleteAttributeLayout({ id }) {
    return apiRequest({
        client: window.API_ISP,
        method: "delete",
        url: `${path}/${id}`
    });
}

export async function createAttributeLayout({ name, description, attributes }) {
    return await apiRequest({
        client: window.API_ISP,
        method: "post",
        url: `${path}`,
        body: {
            name,
            description,
            attributes
        },
    });
}

export async function addAttributeToLayout({ idLayout, sequence, st_check_reply, name, operator, value, client_state, connection_type }) {
    return  await apiRequest({
        client: window.API_ISP,
        method: "post",
        url: `${path}/${idLayout}/addAttribute`,
        body: {
            sequence,
            st_check_reply,
            name,
            operator,
            value,
            client_state,
            connection_type
        },
    });

}

export const updateAttributeLayout = async ({id, name, description, attributes, status}) => {

    const layout = await apiRequest({
        client: window.API_ISP,
        method: "put",
        url: `${path}/${id}`,
        body: {
            name,
            description,
            status
        },
    });

    const currentAttributes = Array.isArray(layout.attributes)
        ? layout.attributes
        : Object.values(layout.attributes || {});

    const currentIds = currentAttributes.map(a => a.id);
    const newIds = attributes.map(a => a.id);

    const attributesToAdd = attributes.filter(a => !currentIds.includes(a.id));

    const attributesToRemove = currentAttributes.filter(a => !newIds.includes(a.id));

    for (const attribute of attributesToAdd) {
        await addAttributeToLayout({ idLayout: id, ...attribute });
    }

    for (const attribute of attributesToRemove) {
        await removeAttributeFromLayout({ idLayout: id, idAttribute: attribute.id });
    }

    if(layout.status != status) {
        const statusChange = status ? 'activate' : 'deactivate';
        await apiRequest({
            client: window.API_ISP,
            method: "put",
            url: `${path}/${id}/${statusChange}`,
            body: {
                name
            },
        });
    }

};

export async function getAttributeLayoutById({id}) {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: `${path}/${id}`
    });
}

export async function duplicateLayoutById({ id }) {
    const originalLayout = await getAttributeLayoutById({ id });
    const original = originalLayout?.data;

    if (!original || !original.name) {
        throw new Error('Layout não encontrado.');
    }

    let baseName = original.name.trim();
    let newName = `${baseName} Copy`;
    let counter = 1;

    let existingLayout = await getAttributeLayout({ name: newName.toLowerCase() });
    while (existingLayout.data.length > 0) {
        newName = `${baseName} Copy (${counter++})`;
        existingLayout = await getAttributeLayout({ name: newName.toLowerCase() });
    }

    const attributesArray = Array.isArray(original.attributes)
        ? original.attributes
        : Object.values(original.attributes || {});

    const transformedAttributes = attributesArray.map(attr => ({
        ...attr,
        name: attr.attribute,
        st_check_reply: attr.stCheckReply,
    }));

    const newLayout = await createAttributeLayout({
        name: newName,
        description: original.description,
        attributes: transformedAttributes,
    });

    return newLayout;
}


export async function getClientState() {
    const response = await  apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: `/classification/e7a983b8-2f09-45fe-96d8-1253f284faa0`
    });

    return response?.data?.options;
}

export const removeAttributeFromLayout = async ({ idLayout, idAttribute }) => {
    try {
        return await apiRequest({
            client: window.API_ISP,
            method: "delete",
            url: `${path}/${idLayout}/remAttribute/${idAttribute}`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};
